import { ProductOrderRM, ProductOrderStatusChangeRM, WorkOrderResponse } from '@herbjoy/apex-api-models';
import { IComponentOptions } from "angular";
import templateUrl from './work-order-detail.component.html';

type WorkOrderVM = WorkOrderResponse & {
    ProductOrdersAndStatus: ProductOrderVM[];
}

type ProductOrderVM = Omit<ProductOrderRM, "StatusHistory"> & {
    StatusHistory: ProductOrderStatusChangeRM;
}

export const WorkOrderDetailComponent: IComponentOptions = {
    templateUrl,
    controllerAs: "vm",
    bindings: {
        workOrder: "<",
        office: "<",
        corporation: "<",
        employee: "<"
    },
    controller: class WorkOrderDetailComponent {
        workOrder: WorkOrderVM;
        commonCustomDetails: any;
        $onChanges() {
            if (this.workOrder) {
                this.commonCustomDetails = this.reduceCommonCustomDetails(this.workOrder);
            }
        }

        reduceCommonCustomDetails(workOrder: WorkOrderVM): any {
            return workOrder.ProductOrdersAndStatus.reduce((result, order) => {
                const custom = order.StatusHistory.CustomDetails;
                if (custom) {
                    const keys = Object.keys(custom).filter(p => p !== "mixed");
                    for (const key of keys) {
                        let value = custom[key];
                        if (typeof(value) === "string") {
                            value = value.trim();
                        }
                        if (value && result[key] && value !== result[key]) {
                            result[key] = "mixed";
                        } else if (value && !result[key]) {
                            result[key] = value;
                        }
                        // Otherwise, either the key is blank or the result keys match, so no action is needed.
                    }
                }
                return result;
            }, {});
        }
    }
};
